import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';

import { EssentialRoutingModule } from './essential-routing.module';
import { EssentialComponent } from './essential.component';

@NgModule({
  declarations: [EssentialComponent],
  imports: [CommonModule, EssentialRoutingModule, SharedModule]
})
export class EssentialModule {}
